export default __webpack_public_path__ + "static/media/grey4-bottom.33dafde6.svg";